var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { boundMethod } from 'autobind-decorator';
import axios from 'axios';
import { ajaxSend, ApiErrorStatusCode } from 'api/api';
export var MessengerSortKey;
(function (MessengerSortKey) {
    MessengerSortKey["CreatedAt"] = "created_at";
    MessengerSortKey["Name"] = "name";
    MessengerSortKey["UpdatedAt"] = "updated_at";
})(MessengerSortKey || (MessengerSortKey = {}));
export class DixaMessengerApiV2 {
    constructor() {
        this.baseUrl = '/v2/messengers';
    }
    fetch(messengerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield ajaxSend({
                method: 'GET',
                path: `${this.baseUrl}/${messengerId}`,
            });
            return response.data;
        });
    }
    fetchAll(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield ajaxSend({
                method: 'GET',
                path: this.baseUrl,
                params: options.params,
            });
            return response;
        });
    }
    create(name, queue) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield ajaxSend({
                path: this.baseUrl,
                method: 'POST',
                data: { name, queue_id: queue },
            });
            return response.data;
        });
    }
    duplicate(messengerId) {
        return __awaiter(this, void 0, void 0, function* () {
            return ajaxSend({
                path: `${this.baseUrl}/${messengerId}/duplicate`,
                method: 'POST',
            });
        });
    }
    deleteBulletinBoard(messengerId) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            // Check if we have a bulletin board to also delete.
            const messengerSettings = yield this.fetch(messengerId);
            const bulletinBoardId = (_b = (_a = messengerSettings.settings) === null || _a === void 0 ? void 0 : _a.integrations.bulletinBoard) === null || _b === void 0 ? void 0 : _b.boardId;
            if (bulletinBoardId) {
                // NOTE: api is defined in `src/api/bulletinboards but due to legacy / new cross import
                // it has been re-defined here.
                try {
                    yield ajaxSend({
                        path: `/v1/bulletinboards/${bulletinBoardId}`,
                        method: 'DELETE',
                    });
                }
                catch (error) {
                    // Don't bother the user if the error is not found, they are trying to delete anyway.
                    if (axios.isAxiosError(error)) {
                        if (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === ApiErrorStatusCode.NotFound) {
                            return;
                        }
                        throw error;
                    }
                }
            }
        });
    }
    delete(messengerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteBulletinBoard(messengerId);
            return ajaxSend({
                path: `${this.baseUrl}/${messengerId}`,
                method: 'DELETE',
            });
        });
    }
    patch(messengerId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield ajaxSend({
                method: 'PATCH',
                path: `${this.baseUrl}/${messengerId}`,
                data: { updates: payload },
            });
            return response.data;
        });
    }
    /**
     * @param id Messenger id
     * @param settings A partial version of settings. Field that are missing will
     *   be ignored, to explicitly delete a fields from settings, set them to
     *   `null`
     */
    patchSettings(id, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield ajaxSend({
                method: 'PATCH',
                path: `${this.baseUrl}/${id}/settings`,
                data: settings,
            });
            return response.data;
        });
    }
    uploadLogo(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new FormData();
            data.append('file', file);
            const response = yield ajaxSend({
                method: 'POST',
                path: `${this.baseUrl}/files`,
                headers: {
                    contentType: 'multipart/form-data',
                },
                data,
            });
            return response;
        });
    }
    /**
     * @returns A void promise that resolves when the account exists and rejects
     *   if it doesn't.
     */
    verifyElevioAccount(accountId) {
        return ajaxSend({
            method: 'GET',
            path: `${this.baseUrl}/elevio-accounts/${accountId}`,
        });
    }
}
__decorate([
    boundMethod
], DixaMessengerApiV2.prototype, "fetchAll", null);
